import satisfiesConditions from './satisfies-conditions'

const getInactiveItems = (items, ctx) => (
  (items || []).filter((item) => !satisfiesConditions(ctx, item.conditions))
)

export default getInactiveItems
